import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, TextInput, InlineNotification } from '@carbon/react';
import { useAuthActions } from 'src/hooks/useAuthActions';

const ForgotPassword = () => {
  const { t } = useTranslation('authentication');
  const { requestPasswordReset, isPending } = useAuthActions();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    await requestPasswordReset(email);
    setSent(true);
  }

  return (
    <Form onSubmit={onSubmit} className="cds--auth__form">
      <h1>{t('forgotPassword.title')}</h1>
      {sent ? (
        <InlineNotification kind="success" title={t('forgotPassword.sent')} lowContrast hideCloseButton />
      ) : (
        <>
          <TextInput
            id="email"
            type="email"
            labelText={t('forgotPassword.email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type="submit" disabled={isPending}>
            {t('forgotPassword.submit')}
          </Button>
        </>
      )}
    </Form>
  );
};

export default ForgotPassword;
